module.exports = __webpack_public_path__ + "fonts/Arial.75400f06.woff";